/* eslint-disable @typescript-eslint/no-explicit-any */
import { CSSProperties } from 'react';
import { Column } from '@tanstack/react-table';
import { TableRow } from '../../../stores/table-store';

export const getCommonPinningStyles = (
  column: Column<TableRow, any>
): { styles: CSSProperties; classNames: string } => {
  const isPinned = column.getIsPinned();
  const isLastLeftPinnedColumn =
    isPinned === 'left' && column.getIsLastColumn('left');
  const isFirstRightPinnedColumn =
    isPinned === 'right' && column.getIsFirstColumn('right');

  const styles = {
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
    minWidth: column.getSize(),
    maxWidth: column.getSize(),
  } as CSSProperties;

  const classNames = `${isPinned ? 'c-editor-table-pinned-cell' : ''} ${isLastLeftPinnedColumn ? 'c-editor-table-pinned-cell--last-left' : ''} ${isFirstRightPinnedColumn ? 'c-editor-table-pinned-cell--first-right' : ''}`;

  return {
    styles,
    classNames,
  };
};
